import { SimpleGrid, SimpleGridProps, useMantineTheme } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "./suspense"
import { debugLog } from "@/utils/debugLog"

interface Props<T> extends SimpleGridProps {
  tileData: T[]
  renderTile: ({ tileData }: { tileData: T }) => React.ReactNode
}

export function TileGrid<T>({ tileData, renderTile, ...props }: Props<T>) {
  const { breakpoints } = useMantineTheme()
  React.useEffect(() => {
    debugLog("TileGrid breakpoints", breakpoints)
  }, [breakpoints])
  return (
    <SimpleGrid
      cols={{ base: 1, md: 2, xl: 3, xxl: 4, xxxl: 5, xxxxl: 6 }}
      spacing={{ base: "sm", sm: "md" }}
      {...props}
    >
      {tileData.map((data, i) => (
        <SuspenseWithErrorBoundary key={i}>
          {renderTile({ tileData: data })}
        </SuspenseWithErrorBoundary>
      ))}
    </SimpleGrid>
  )
}
